<template>
  <div class="home-wrapper">
    <div class="box">
      <!-- <img src="../../assets/right.png" class="pic" /> -->
      <img class="success" src="https://aweqn.zhiandexpo.com/success2027.png" alt="pic">
      <div class="succ">{{ apply_type == 1 ? "报名成功" : "修改成功" }}</div>
      <div class="kuang">
        <div class="name">{{ info.name }}</div>
        <div class="name" style="color: #1C519A">{{ info.customerType }}</div>
      </div>
      <!-- <div class="txt">
        <img class="icon" src="https://aweqn.zhiandexpo.com/time2025.png" />
        <span>{{ info.openDate }}</span>
      </div> -->
      <div class="txt">
        <img class="icon" src="https://aweqn.zhiandexpo.com/address2026.png" />
        <span>{{ info.address }}</span>
      </div>
      <div class="btm-box">
        <div class="block-box">
          <div class="left">参观入场时间</div>
          <div class="right">
            <div v-for="(item, index) in info.date_info" :key="index" class="">
              {{ item }}
            </div>
          </div>
        </div>
        <div v-if="timeList.length > 0 || is_reservation == 1" class="block-box">
          <div class="left">预约时间</div>
          <div class="right">
            <div v-for="(item, index) in timeList" :key="index" class="yyItem">{{item.date}} {{item.time == 1 ? '上午' : '下午'}}</div>
          </div>
        </div>
        <div v-if="info.activity_title.length > 0" class="block-box">
          <div class="left">报名活动</div>
          <div class="right">
            <div v-for="(item,index) in info.activity_title" :key="index" class="actName">{{ item }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="yytime">
        <div v-if="timeList.length > 0 || is_reservation == 1" class="yytitle">预约时间</div>
        <div class="yyDateBox">
          <div v-for="(item, index) in timeList" :key="index" class="yyItem">{{item.date}} {{item.time == 1 ? '上午' : '下午'}}</div>
        </div>
      </div> -->
      <!-- <div v-if="info.activity_title.length > 0" class="actTit">
        <span class="actsTit">报名活动</span>
        <div class="actName_box">
          <div v-for="(item,index) in info.activity_title" :key="index" class="actName">{{ item }}</div>
        </div>
      </div> -->
      <div class="tip">
        <div v-html="info.success_info"></div>
      </div>
      <div class="point_box">
        <div class="point yellow" />
        <div class="point brown" />
        <div class="point blue" />
      </div>
      <!-- 本届只做新国际展区：东方枢纽相关文案整体隐藏 -->
      <div v-if="showEastEntry" class="tip">
        <p>AWE2027还有<span style="color: #F08200">上海东方枢纽国际商务合作区展区</span></p>
        <p>邀您探索消费电子先进科技！</p>
      </div>
      <div class="line">
        <div v-if="!isEnd" style="margin-top: 10px; margin-left: 20px" class="submit change" @click="changeSign">修改信息/协助注册</div>

        <!-- 本届只做新国际展区：东方枢纽报名按钮隐藏 -->
        <div v-if="showEastEntry" style="margin-top: 10px; margin-left: 20px" class="submit goEast" @click="goEast">东方枢纽观众报名</div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="close"
      :close-on-press-escape="close"
      :show-close="close"
      :visible.sync="pop"
      width="628px"
    >
      <div class="title">
        请选择您的入场时间
        <!-- <span class="stitle">（*蓝色加粗数字为可预约余量）</span> -->
      </div>
      <div class="timeList">
        <div v-for="(item, index) in keyList" :key="index" class="item">
          <div class="time">
            {{ item.split("-")[1] + "月" + item.split("-")[2] + "日" }}
          </div>
          <div class="checkBox">
            <div
              v-for="(itm, idx) in dateList[item]"
              :key="idx"
              class="checkItem"
              :class="ids.find((e) => e == itm.id) ? 'checked' : ''"
              @click="clickId(item, idx)"
            >
              <div class="item-top">
                <!-- <div class="code">
                  {{ itm.code }}
                </div> -->
                <div class="sd">
                  {{ itm.time == 1 ? "上午" : "下午" }}
                </div>
              </div>
              <!-- <div class="item-mid">
                {{ itm.time == 1 ? "8:00-12:00" : "13:00-17:00" }}
              </div>
              <div class="item-btm">
                {{ itm.left_count }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        <div class="submit" @click="submit">确认</div>
        <!-- <div class="cancel" @click="cancel">暂不选择</div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { customerApplyResult, getEnterTime, userReservation, checkEnterTime } from "../../api/data";
export default {
  data() {
    return {
      info: {},
      apply_type: 1,
      pop: false,
      close: false,
      dateList: [],
      keyList: [],
      ids: [],
      timeList: [],
      is_reservation: 1,
      forum_title: '',
      isEnd: false,
      // 本届只做新国际展区：东方枢纽入口整体隐藏。
      // 恢复时把 showEastEntry 改回 true 即可，其余逻辑无需改动。
      showEastEntry: false
    };
  },
  created() {
    this.getInfo();
    // 当前时间
    let nowDay = new Date()
    // 到期时间
    // 换届：AWE2026 会期 3.12-15 -> AWE2027 会期 3.17-20，旧值 2026/3/15 12:00:00
    let fDay = new Date("2027/3/20 12:00:00")
    if (nowDay.valueOf() > fDay.valueOf()) {
      // 展会结束
      this.isEnd = true
    }
  },
  mounted() {
    this.apply_type = this.$route.query.apply_type;
    this.getTime();
    this.getUserTime()
  },
  methods: {
    getInfo() {
      customerApplyResult({ customerApplyId: this.$route.query.id }).then(
        (res) => {
          if (res.code === 0) {
            this.info = res.data;
            this.is_reservation = res.data.is_reservation
            this.forum_title = res.data.forum_title
            // this.productClass = res.data.productClass
            // this.findChannel = res.data.findChannel
            // this.jobLevel = res.data.jobLevel
          }
        }
      );
    },
    getTime() {
      getEnterTime().then((res) => {
        if (res.code == 0) {
          this.dateList = res.data.reduce(
            (r, x) => ((r[x.date] || (r[x.date] = [])).push(x), r),
            {}
          );
          var key = [];
          res.data.map((item) => {
            key.push(item.date);
          });
          for (var i = 0; i < key.length; i++) {
            if (this.keyList.indexOf(key[i]) === -1) {
              this.keyList.push(key[i]);
            }
          }
        }
      });
    },
    getUserTime() {
      userReservation({mobile: this.$route.query.mobile}).then(res => {
        if(res.code == 0) {
          this.ids = []
          this.timeList = res.data

          res.data.map(item => {
            this.ids.push(item.id)
          })
        }
      })
    },
    clickId(item, idx) {
      this.ids.indexOf(this.dateList[item][idx].id)
      if (this.ids.indexOf(this.dateList[item][idx].id) > -1) {
        this.ids.splice(this.ids.indexOf(this.dateList[item][idx].id), 1)
      } else {
        this.ids.push(this.dateList[item][idx].id)
      }
    },
    changeTime() {
      this.pop = true
    },
    changeSign() {
      this.$router.push({
        name: 'form',
        query: {
          id: this.$route.query.id
        }
      })
    },
    goEast() {
      // 正式环境把页面域名里的 test 去掉(awesngbmtest→awesngbm)；测试/本地原样
      var u = `https://awesngbmtest.zhiandexpo.com/form?channel_id=${this.$route.query.channel_id}&applyId=${this.$route.query.id}&isnew=1&loginType=2&mobile=${this.$route.query.mobile}&email=${this.$route.query.email}`
      var h = (typeof location !== 'undefined' && location.hostname) || '';
      var isTest = !h || /test/i.test(h) || h === 'localhost' || h === '127.0.0.1' || /^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(h);
      window.location.href = isTest ? u : u.replace('test.zhiandexpo.com', '.zhiandexpo.com')
    },
    cancel() {
      this.pop = false
      this.getUserTime()
    },
    submit() {
      const data = { ids: this.ids, is_en: 0 }
      if (this.mobile != '') {
        data.mobile = this.$route.query.mobile
      }
      checkEnterTime(data).then(res => {
        if (res.code === 0) {
          this.pop = false
          this.getUserTime()
        }
      })
    }
  },
  // created() {
  //   let u = navigator.userAgent;
  //   if (u.indexOf("iPhone") > -1) {
  //     inobounce.enable();
  //   }
  // },
  // beforeDestroy() {
  //   inobounce.disable();
  // },
};
</script>



<style scoped>
.actTit {
  margin-top: 10px;
  display: flex;
}
.actsTit {
  color: #333;
  margin-right: 7px;
}
.actName {
  color: #66BF97;
}
.home-wrapper {
  width: 100%;
  height: 100%;
  background: url("https://aweqn.zhiandexpo.com/awe2027pc.jpg") no-repeat;
  background-size: contain;
  padding-top: 400px;
  padding-bottom: 200px;
}
.box {
  width: 1200px;
  /* height: 820px; */
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.24);
  border-radius: 27px;
  margin: 0 auto;
  padding: 50px 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -50px;
}
.success {
  width: 97px;
  height: 91px;
}
.pic {
  width: 196px;
  height: 146px;
}
.succ {
  font-size: 16px;
  padding: 28px 0;
}
.kuang {
  width: 310px;
  height: 95px;
  /* background: url("../../assets/box.png") no-repeat; */
  /* border: 1px solid #1C519A; */
  background: url('https://aweqn.zhiandexpo.com/companybg.png') no-repeat;
  background-size: 100% 100%;
  margin-bottom: 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
/* .name {
  padding-bottom: 10px;
  padding-top: 10px;
} */
.txt {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.icon {
  width: 14px;
  height: 16px;
  margin-right: 5px;
}
.point_box {
  display: flex;
  margin-top: 20px;
}
.point {
  width: 10px;
  height: 10px;
  border-radius: 10px;
}
.yellow {
  background: #ffdd70;
}
.brown {
  background: #fa933a;
  margin: 0 5px;
}
.blue {
  background: #00aacb;
}
.block-box {
  width: 310px;
  height: 60px;
  /* line-height: 60px; */
  text-align: left;
  background: rgba(242, 242, 242, 0.5);
  border-radius: 6px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.left {
  width: 114px;
  height: 100%;
  line-height: 60px;
  text-align: center;
  color: #666;
  font-weight: bold;
  background: rgba(242, 242, 242, 0.5);
}
.right {
  width: 196px;
  height: 100%;
  display: flex;
  margin-left: 15px;
  align-items: left;
  justify-content: center;
  flex-direction: column;
  color: #666666;
  font-weight: 400;
}

.yytime {
  font-size: 16px;
  color: #2A2A27;
  margin-top: 15px;
}
.line {
  display: flex;
}
.yyItem {
  text-align: center;
}
.yytitle {
  font-weight: 500;
  text-align: center;
}
.tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}
.tip>p {
  padding: 0;
  margin: 0;
}
.title {
  font-size: 18px;
  color: #000;
  font-weight: 500;
}
.stitle {
  font-size: 12px;
  color: #1C519A;
  font-weight: 400;
}
.timeList {
  display: flex;
  flex-wrap: wrap;
}
.item {
  width: 118px;
  /* margin-bottom: 20px;
  margin-right: 24px; */
  margin: 20px 24px 20px 0;
}
.time {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 16px;
}
.checkBox {
  width: 118px;
  height: 204px;
}
.checkItem {
  width: 118px;
  height: 82px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #999;
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}

.checked {
  border: 1px solid #1C519A;
  color: #333333;
}
.item-top {
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-btm {
  color: #1C519A;
}
.code {
  font-weight: 500;
  margin-right: 4px;
}
.btn {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.submit {
  cursor: pointer;
  width: 190px;
  height: 32px;
  background: #1C519A;
  border-radius: 17px;
  border: 1px solid #1C519A;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #fff;
}
.change {
  background: #1C519A;
	color: #fff;
  border: 0;
}
.goEast {
  color: #fff;
  background: #F08200;
  border: 0;
}
.cancel {
  cursor: pointer;
  width: 190px;
  height: 32px;
  border-radius: 17px;
  border: 1px solid #1C519A;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #1C519A;
  margin-top: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/done.vue